export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 会话列表
    getConversationList: function getConversationList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/getList",
        method: "get",
        params: data
      });
    },
    // 聊天记录
    getChatRecord: function getChatRecord() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/getRecord",
        method: "get",
        params: data
      });
    },
    // 发送消息
    sendMessage: function sendMessage() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/sendMsg",
        method: "post",
        data: data
      });
    },
    getMonitorByKeyword: function getMonitorByKeyword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/getMonitorByKeyword",
        method: "get",
        params: data
      });
    },
    // 设置IM会话状态
    setImConversationStatus: function setImConversationStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/setStatus",
        method: "post",
        data: data
      });
    },
    getImMonitorKeywordsList: function getImMonitorKeywordsList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        // url: "/api/v1/admin/resource/im/search/paged/",
        // url: "/admin/im/monitor",
        url: "/api/v3/admin/im/monitor",
        method: "get",
        params: data
      });
    },
    addImMonitorKeyword: function addImMonitorKeyword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/addKeyword",
        method: "post",
        data: data
      });
    },
    updateImMonitorKeyword: function updateImMonitorKeyword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/updateKeyword",
        method: "post",
        data: data
      });
    },
    getImMonitorRiskByKeyword: function getImMonitorRiskByKeyword() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/getRiskByKeyword",
        method: "get",
        params: params
      });
    },
    deleteImMonitorKeyword: function deleteImMonitorKeyword() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/im/deleteKeyword",
        method: "post",
        data: data
      });
    },
    getGroupSendMessageUserList: function getGroupSendMessageUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/intention/match",
        method: "get",
        params: data
      });
    },
    groupSendMessage: function groupSendMessage() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/promotion/apartment",
        method: "post",
        data: data
      });
    },
    toggleImVersion: function toggleImVersion() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/tencent/im/toggleTencent",
        method: "post",
        data: data
      });
    }
  };
});